import React from 'react';

const Signup = () => {
  return <h1>This is the signup page</h1>;
};

export default Signup;
